import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageUserManagementService {

  constructor(private service: PHBHPApiService) { }

  // registerUser(data) {
  //   return this.service.postApi("UserProfile/AddUser", data, true);
  // }
  registerUser(data) {
    return this.service.postApi("UserProfile/AddUserOrSubscribe", data, true);
  }
  getUserRolesForId(roleId) {
    return this.service.getApi("UserRoles/GetUserRolesForId/"+roleId, true);
  }
  getAllUsers(userId) {
    return this.service.getApi("UserProfile/GetUsersForId/"+userId, true);
  }
  deleteUser(userId,forceDelete = false) {
    //return this.service.deleteApi("Users/"+userId, true);
    return this.service.deleteApi(`UserProfile/${userId}/${forceDelete}`, true);
  }
  getUserByUserId(userId) {
    return this.service.getApi("UserProfile/GetUserDetails/"+userId, true);
  }
  updateUserById(data,userId){
    return this.service.putApi("UserProfile/UpdateUserDetails/"+userId, data, true);
  } 
  getUsersBountry(id) {
    return this.service.getApi("UserProfile/GetUsersBountryRolesAndInstitutions/"+id, true);
  }
  getUsernameExist(id) {
    return this.service.getApi("UserProfile/CheckUserNameAvailability/"+id, true);
  }
  getUserEmailExist(id) {
    return this.service.getApi("Users/UserEmailExist/"+id, true);
  }
  getCountriesKeyValuePair() {
    return this.service.getApi("countries/GetCountriesKeyValuePair", true);
  }
  getInstitutionById(id) {
    return this.service.getApi('Institutions/GetInstitution/' + id, true);
  }
}

